import { Component, NgModule, OnInit } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './components/visitantes/inicio/inicio.component';
import { SignInComponent } from './components/autenticacion/sign-in/sign-in.component';
import { SignUpComponent } from './components/autenticacion/sign-up/sign-up.component';
import { SignInForgotPasswordComponent } from './components/autenticacion/sign-in-forgot-password/sign-in-forgot-password.component';
import { SignInVerifyEmailComponent } from './components/autenticacion/sign-in-verify-email/sign-in-verify-email.component';
import { FormInstructorComponent } from './components/admin/instructores/form-instructor/form-instructor.component';
import { FormEmpresasComponent } from './components/admin/empresas/form-empresas/form-empresas.component';
import { ListaInstructoresComponent } from './components/admin/instructores/lista-instructores/lista-instructores.component';
import { ListaEmpresasComponent } from './components/admin/empresas/lista-empresas/lista-empresas.component';
import { DetalleEmpresasComponent } from './components/visitantes/detalle-empresas/detalle-empresas.component';
import { DetalleInstructorComponent } from './components/visitantes/detalle-instructor/detalle-instructor.component';
import { DetalleCursoComponent } from './components/visitantes/detalle-curso/detalle-curso.component';
import { BuscarComponent } from './components/visitantes/buscar/buscar.component';
import { MiCuentaEstudianteComponent } from './components/estudiante/mi-cuenta-estudiante/mi-cuenta-estudiante.component';
import { ListaCursosComponent } from './components/admin/cursos/lista-cursos/lista-cursos.component';
import { DetalleCursoCompradoComponent } from './components/estudiante/detalle-curso-comprado/detalle-curso-comprado.component';
import { MisCursosComponent } from './components/estudiante/mis-cursos/mis-cursos.component';
import { ComprarCursoComponent } from './components/estudiante/comprar-curso/comprar-curso.component';
import { AdminComponent } from './components/admin/admins/admin/admin.component';
import { ModuloComponent } from './components/estudiante/modulo/modulo.component';
import { CertificadoComponent } from './components/visitantes/certificado/certificado.component';
import { TerminosCondicionesComponent } from './components/informativas/terminos-condiciones/terminos-condiciones.component';
import { PoliticaPrivacidadComponent } from './components/informativas/politica-privacidad/politica-privacidad.component';
import { SoporteComponent } from './components/informativas/soporte/soporte.component';
import { CapacitacionEmpresasComponent } from './components/informativas/capacitacion-empresas/capacitacion-empresas.component';
import { EnsenaComponent } from './components/informativas/ensena/ensena.component';
import { ResumenInstructorComponent } from './components/instructor/resumen-instructor/resumen-instructor.component';
import { UserRolesComponent } from './components/admin/admins/user-roles/user-roles.component';
import { CuestionarioComponent } from './components/estudiante/cuestionario/cuestionario.component';
import { ValorarCursoComponent } from './components/estudiante/valorar-curso/valorar-curso.component';
import { DashboardAdminEmpresaComponent } from './components/admin/empresas-cliente/dashboard-admin-empresa/dashboard-admin-empresa.component';
import { ResultadoCuestionarioComponent } from './components/estudiante/resultado-cuestionario/resultado-cuestionario.component';
import { EditarCursoComponent } from './components/admin/cursos/editar-curso/editar-curso.component';
import { ResetPasswordComponent } from './components/autenticacion/reset-password/reset-password.component';
import { ListaAdminsComponent } from './components/admin/admins/lista-admins/lista-admins.component';
import { ListaCategoriasComponent } from './components/admin/lista-categorias/lista-categorias.component';
import { ListaEmpresasClienteComponent } from './components/admin/empresas-cliente/lista-empresas-cliente/lista-empresas-cliente.component';
import { ListaEstudiantesComponent } from './components/admin/estudiantes/lista-estudiantes/lista-estudiantes.component';
import { ResumenAdminComponent } from './components/admin/resumen-admin/resumen-admin.component';
import { VentasComponent } from './components/admin/ventas/ventas/ventas.component';
import { RegistrarPagosComponent } from './components/admin/ventas/registrar-pagos/registrar-pagos.component';
import { FormEmpresaClienteComponent } from './components/admin/empresas-cliente/form-empresa-cliente/form-empresa-cliente.component';
import { DetallePagoComponent } from './components/admin/ventas/detalle-pago/detalle-pago.component';
import { PagosComponent } from './components/admin/ventas/pagos/pagos.component';
import { SignInInstructorComponent } from './components/autenticacion/sign-in-instructor/sign-in-instructor.component';
import { EstComponent } from './components/estudiante/est/est.component';
import { InstComponent } from './components/instructor/inst/inst.component';
import { SignUpInstructorComponent } from './components/admin/instructor/sign-up-instructor/sign-up-instructor.component';
import { SpinnerComponent } from './components/app-base/spinner/spinner.component';
import { FAQComponent } from './components/informativas/faq/faq.component';
import { HtmlEditorComponent } from './components/admin/cursos/html-editor/html-editor.component';
import { ChatSoporteComponent } from './components/visitantes/chat-soporte/chat-soporte.component';
import { SoporteChatAdminComponent } from './components/admin/soporte-chat-admin/soporte-chat-admin.component';
import { VentaManualComponent } from './components/admin/ventas/venta-manual/venta-manual.component';
import { PoliticaCookiesComponent } from './components/informativas/politica-cookies/politica-cookies.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { DetalleFacturaComponent } from './components/admin/detalle-factura/detalle-factura.component';

const routes: Routes = [

  // INFORMATIVAS
  { path: 'capacitacion-empresas', component: CapacitacionEmpresasComponent },
  { path: 'ensena', component: EnsenaComponent },
  { path: 'politica-privacidad', component: PoliticaPrivacidadComponent },
  { path: 'soporte', component: SoporteComponent },
  { path: 'terminos-condiciones', component: TerminosCondicionesComponent },
  { path: 'faq', component: FAQComponent },
  { path: 'spinner', component: SpinnerComponent},

  // VISITANTES
  { path: '', component: InicioComponent },
  { path: 'buscar', component: BuscarComponent },
  { path: 'certificado/:id', component: CertificadoComponent },
  { path: 'curso/:id', component: DetalleCursoComponent },
  { path: 'instructor/:id', component: DetalleInstructorComponent },
  { path: 'empresa/:id', component: DetalleEmpresasComponent },
  { path: 'comprar-curso', component: ComprarCursoComponent },  
  { path: 'comprar-curso/:id', component: ComprarCursoComponent },
  { path: 'chat-soporte', component: ChatSoporteComponent },
  { path: 'politica-cookies', component: PoliticaCookiesComponent },

  // AUTH
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-in-instructor', component: SignInInstructorComponent },


  // USUARIO ESTUDIANTE
  {
    path: 'est', component: EstComponent,
    children: [
      { path: 'mi-cuenta', component: MiCuentaEstudianteComponent },
      { path: 'mis-cursos', component: MisCursosComponent },
      { path: 'mi-curso/:id', component: DetalleCursoCompradoComponent },
      { path: 'modulo/:id', component: ModuloComponent },
      { path: 'cuestionario/:id', component: CuestionarioComponent },
      { path: 'resultado-cuestionario', component: ResultadoCuestionarioComponent },
      // { path: 'detalle-factura', component: DetalleFacturaComponent },
      { path: 'detalle-factura/:id/:uid', component: DetalleFacturaComponent },

    ]
  },

  // USUARIO INSTRUCTOR
  {
    path: 'inst', component: InstComponent,
    children: [
      { path: 'resumen/:id', component: ResumenInstructorComponent },
      { path: 'resumen', component: ResumenInstructorComponent },
      { path: 'detalle-pago/:id', component: DetallePagoComponent },
    ]
  },

  // ADMINS
  {
    path: 'admin' ,
    component: AdminComponent,
    children: [
      { path: 'resumen', component: ResumenAdminComponent },
      { path: 'lista-admins', component: ListaAdminsComponent },
      { path: 'lista-cursos', component: ListaCursosComponent },
      { path: 'form-curso', component: EditarCursoComponent },
      { path: 'form-curso/:id', component: EditarCursoComponent }, // faltaprobar
      { path: 'lista-instructores', component: ListaInstructoresComponent },
      { path: 'form-instructores', component: FormInstructorComponent },
      { path: 'form-instructores/:id', component: FormInstructorComponent }, //falta probar
      { path: 'lista-empresas', component: ListaEmpresasComponent },
      { path: 'form-empresas', component: FormEmpresasComponent },
      { path: 'form-empresas/:id', component: FormEmpresasComponent },//falta probar
      { path: 'lista-estudiantes', component: ListaEstudiantesComponent },
      { path: 'ventas', component: VentasComponent },
      { path: 'ventas/:id', component: VentasComponent }, //falta probar
      { path: 'venta-manual', component: VentaManualComponent },
      { path: 'pagos', component: PagosComponent },
      { path: 'pagos/:id', component: PagosComponent },
      { path: 'detalle-pago', component: DetallePagoComponent },
      { path: 'detalle-pago/:id', component: DetallePagoComponent }, //falta probar
      { path: 'sign-up-instructor', component: SignUpInstructorComponent },
      { path: 'editor-html', component: HtmlEditorComponent },
      { path: 'soporte-chat', component: SoporteChatAdminComponent },

      

      // { path: 'lista-categorias', component: ListaCategoriasComponent }, // DESHABILITADO TEMPORALMENTE
      // Manejo de empresas cliente
      // { path: 'lista-empresas-cliente', component: ListaEmpresasClienteComponent }, // DESHABILITADO TEMPORALMENTE
      // { path: 'form-empresa-cliente', component: FormEmpresaClienteComponent }, // DESHABILITADO TEMPORALMENTE
      // { path: 'form-empresa-cliente/:id', component: FormEmpresaClienteComponent }, // DESHABILITADO TEMPORALMENTE
      // { path: 'dashboard-admin-empresa/:id', component: DashboardAdminEmpresaComponent }, // DESHABILITADO TEMPORALMENTE
    ]
  },

  { path: '**', redirectTo: '' },


]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
